// 资质证书放大查看（对齐 Nuxt pages/about/honor.vue 的 cert modal）
// 区块在 pjax 容器里，每次页面加载后重新找一次元素并绑一次；
// 用 dataset 标记避免同一次加载里重复绑定（hook 可能被触发多次）。
_iro.hooks.onPageLoaded(() => {
    const modal = document.querySelector(".iro-page-honor .cert-modal");
    const thumb = document.querySelector(".iro-page-honor [data-cert-open]");

    if (!modal || !thumb || thumb.dataset.certBound === "1") {
        return;
    }

    thumb.dataset.certBound = "1";

    const open = () => modal.classList.add("is-open");
    const close = () => modal.classList.remove("is-open");

    thumb.addEventListener("click", open);
    thumb.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            open();
        }
    });

    modal.querySelector("[data-cert-close]")?.addEventListener("click", close);
    modal.addEventListener("click", (event) => {
        if (event.target === modal) {
            close();
        }
    });
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            close();
        }
    });
});
